import { Directive, Input, ChangeDetectorRef, Host, Self, OnInit, SimpleChanges, SimpleChange, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { PagedResultModel } from 'shared/definition';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { TotalTemplateComponent } from 'shared/components/total-template/total-template.component';

@Directive({
  selector: '[pagedData]'
})
export class PagedDataDirective implements OnInit {


  constructor(
    @Host() @Self() private nzTable: NzTableComponent,
    private changeDetectorRef: ChangeDetectorRef,
    private resover: ComponentFactoryResolver,
    private viewContainerRef: ViewContainerRef
  ) {


  }

  ngOnInit(): void {
    const nzFrontPagination = this.nzTable.nzFrontPagination;
    const nzShowTotal = this.nzTable.nzTotal;
    this.nzTable.nzFrontPagination = false;

    var factory = this.resover.resolveComponentFactory(TotalTemplateComponent);
    var componentRef = this.viewContainerRef.createComponent(factory);

    this.nzTable.nzShowTotal=componentRef.instance.template;

    this.nzTable.ngOnChanges({ nzFrontPagination: new SimpleChange(nzFrontPagination, this.nzTable.nzFrontPagination, true) });

    this.nzTable.ngOnChanges({ nzShowTotal: new SimpleChange(nzShowTotal, this.nzTable.nzShowTotal, true) });


  }




  @Input()
  set pagedData(_: PagedResultModel<any>) {

    if (!_) return;
    this.nzTable.nzData = _.data;
    this.nzTable.nzPageIndex = _.pageIndex;
    this.nzTable.nzTotal = _.totalCount;
    this.nzTable.nzPageSize = _.pageSize;

    const changes: SimpleChanges = {
      nzData: new SimpleChange(this.nzTable.nzData, _.data, false),
      nzPageIndex: new SimpleChange(this.nzTable.nzPageIndex, _.pageIndex, false),
      nzTotal: new SimpleChange(this.nzTable.nzTotal, _.totalCount, false),
      nzPageSize: new SimpleChange(this.nzTable.nzPageSize, _.pageSize, false)
    };
    // changes.nzData=_.data;
    this.nzTable.ngOnChanges(changes);

  }



}
